import { Recapt } from './engine';
import {
  FeedbackPayload,
  SessionIdentity,
  StartOptions,
  TrackEvent,
} from './types';

type PayloadMap = {
  identify: SessionIdentity;
  start: StartOptions;
  'add-action': string;
  tag: string;
  track: TrackEvent;
  feedback: FeedbackPayload;
  stop: undefined;
  persist: undefined;
  pause: undefined;
  resume: undefined;
  'use-system-painpoints': undefined;
  terminate: undefined;
  destroy: undefined;
};

type RecaptAction = keyof PayloadMap;

type RecaptMethod = <T extends RecaptAction>(
  action: T,
  ...args: PayloadMap[T] extends undefined ? [] : [data: PayloadMap[T]]
) => void;

export const recapt: RecaptMethod = (
  action,
  data?: PayloadMap[RecaptAction],
) => {
  switch (action) {
    case 'identify':
      if (!data) return Recapt.warn(action, 'requires args');
      Recapt.session.setIdentity(data as SessionIdentity);
      break;
    case 'start':
      if (!data) return Recapt.warn(action, 'requires args');
      Recapt.start(data as StartOptions);
      break;
    case 'stop':
      Recapt.stop();
      break;
    case 'persist':
      Recapt.persist();
      break;
    case 'pause':
      Recapt.pause();
      break;
    case 'resume':
      Recapt.resume();
      break;
    case 'use-system-painpoints':
      Recapt.useSystemPainpoints();
      break;
    case 'terminate':
      Recapt.terminate();
      break;
    case 'destroy':
      Recapt.destroy();
      break;
    case 'add-action':
      if (!data) return Recapt.warn(action, 'requires args');
      Recapt.addAction(data as string);
      break;
    case 'tag':
      if (!data) return Recapt.warn(action, 'requires args');
      Recapt.tag(data as string);
      break;
    case 'track':
      if (!data) return Recapt.warn(action, 'requires args');
      Recapt.track(data as TrackEvent);
      break;
    case 'feedback':
      if (!data) return Recapt.warn(action, 'requires args');
      Recapt.feedback(data as FeedbackPayload);
      break;
    default:
      break;
  }
};
